import React from "react";
import styles from "./UnreadMsg.module.scss";

type PROPS = {
  count: number;
};

const UnreadMsg: React.FC<PROPS> = ({ count }) => {
  return (
    <div className={styles.root}>
      <div className={styles.content}>unread</div>
    </div>
  );
};

export default UnreadMsg;
